import { Image } from '~/components/Image';
import Tag from '~/components/Tag';
import { COLORS } from '~/components/Tag/colors';
import Text from '~/components/Text';
import { Toggle } from '~/components/Toggle';

import type { Publication } from '~/interfaces/publication';

interface Props {
  publication: Publication;
  selected: boolean;
  onToggle: (id: string) => void;
}

export default function PublicationListItem({ publication, selected, onToggle }: Props) {
  const colorKeys = Object.keys(COLORS);

  return (
    <li className="relative w-full px-2 py-2 border rounded-lg">
      <div className="h-full space-y-4">
        <div className="flex justify-between h-full p-4 rounded">
          <div className="flex flex-col justify-between space-y-4">
            <div className="flex flex-col space-y-4">
              <div className="flex-shrink-0 mb-4 sm:mb-0 sm:mr-4">
                <div className="w-16 h-16 overflow-hidden bg-white border border-gray-300 rounded">
                  <Image maxWidth={128} aspectRatio={'square'} src={publication.logo.url} alt={publication.name} />
                </div>
              </div>

              <div className="space-y-0.5">
                <Text as="h4" type="title" size="xl" theme={'default'} className="font-semibold">
                  {publication.name}
                </Text>

                <Text as="p" type="body" size="sm" theme={'default'}>
                  {publication.description}
                </Text>
              </div>

              <div className="flex flex-wrap gap-2">
                {publication.tags?.map((tag, index) => {
                  const color = colorKeys[index] as keyof typeof COLORS;

                  return <Tag key={tag.name} text={tag.name} color={color} />;
                })}
              </div>
            </div>

            <div className="pt-4">
              <a target="_blank" rel="noreferrer" href={publication.url}>
                <Text
                  as="span"
                  type="body"
                  size="sm"
                  theme={'default'}
                  className="font-semibold text-wt-primary opacity-60"
                >
                  Read
                </Text>
              </a>
            </div>
          </div>
          <div className="absolute right-6 top-6">
            <Toggle enabled={selected} onToggle={() => onToggle(publication.id)} />
          </div>
        </div>
      </div>
    </li>
  );
}
